import React from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'

const Grid = ({ direction, margin, padding, extraClasses, children, ...otherProps }) => (
  <div className={classnames(direction, margin, padding, extraClasses)} {...otherProps}>
    {children}
  </div>
)

Grid.propTypes = {
  children: PropTypes.any.isRequired,
  extraClasses: PropTypes.string,
  margin: PropTypes.string,
  padding: PropTypes.string,
  direction: PropTypes.string
}

Grid.defaultProps = {
  extraClasses: '',
  direction: 'grid-x',
  margin: '',
  padding: ''
}

export default Grid
